
import { useParams, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { SliderField, Heading, Flex, Button, SelectField, Text, View, Divider} from '@aws-amplify/ui-react';
import "@aws-amplify/ui-react/styles.css";
import Timeline, {
  TimelineHeaders,
  SidebarHeader,
  TodayMarker,
  TimelineMarkers
} from 'react-calendar-timeline/lib'
import 'react-calendar-timeline/lib/Timeline.css'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import ReservationNew from './reservation_new';
import {useNavigate} from 'react-router-dom';
import Reservationcreate from "../components/reservationcreate";
import { hatchedBarStyle, insuranceBufferStripe } from "../components/insuranceBufferStripe";

const OPEN_RESERVATION_STATUSES = new Set([
  "deposit",
  "price",
  "remaining",
  "extension",
]);

function vehicleGroupRenderer({ group }) {
  const background = group.openBackground;
  const note = group.attentionNote || "";
  const reservationTitle = group.reservationTitle || "";
  return (
    <div
      title={reservationTitle || undefined}
      style={{
        background: background || undefined,
        margin: background ? "0 -4px" : undefined,
        padding: background ? "0 4px" : undefined,
        height: "100%",
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          paddingRight: note ? "0.9rem" : undefined,
        }}
      >
        {group.title}
      </div>
      {note ? (
        <span
          style={{
            position: "absolute",
            right: 2,
            top: 0,
            color: "#7F1D1D",
            fontWeight: 700,
          }}
        >
          *
        </span>
      ) : null}
    </div>
  );
}

function queueTimelineStyle(rsvn, baseBackground) {
  const kind = rsvn.queue_kind;
  if (kind === "approval") {
    return {
      background: "DarkOrange",
      padding: "0px",
      border: "2px solid SaddleBrown",
    };
  }
  if (kind === "handoff_warn") {
    return {
      background: "Gold",
      padding: "0px",
      border: "2px dashed DarkGoldenrod",
    };
  }
  return { background: baseBackground, padding: "0px" };
}

function queueTimelineTitle(rsvn, baseTitle) {
  const kind = rsvn.queue_kind;
  if (kind === "approval") {
    const trigger = rsvn.queue_trigger || "?";
    const action = rsvn.queue_action || "review";
    let title =
      `[Cancel/close review — ${trigger} ${action} pending approval] ` + baseTitle;
    if (rsvn.queue_reason) {
      title += " | " + rsvn.queue_reason;
    }
    return title;
  }
  if (kind === "handoff_warn") {
    let title =
      "[Handoff warning — do not close without opening the next reservation] " +
      baseTitle;
    if (rsvn.queue_reason) {
      title += " | " + rsvn.queue_reason;
    }
    return title;
  }
  return baseTitle;
}

function calendarFromApi3(body) {
  const vehicles = Array.isArray(body && body.vehicles) ? body.vehicles : [];
  const reservations = Array.isArray(body && body.reservations) ? body.reservations : [];
  return {
    status: (body && body.status) || "success",
    attentionReady: !body || body.attentionReady !== false,
    max_name_width: body && body.maxNameWidth ? body.maxNameWidth : 30,
    tz_choices: ["ET", "CT", "MT", "PT"],
    drivers: ["0:Not A Scheduled Driver"],
    cars: vehicles.map((car) => ({id: car.id, name: car.name})),
    rsvns: reservations.map((row) => ({
      res_id: row.resId,
      carId: row.carId,
      driverName: row.driverName,
      status: row.status,
      start_unix: row.startUnix,
      end_unix: row.endUnix,
      block_end_unix: row.blockEndUnix,
      startString: row.startString,
      endString: row.endString,
      queue_kind: row.queueKind,
      queue_trigger: row.queueTrigger,
      queue_action: row.queueAction,
      queue_reason: row.queueReason,
      operatorAttention: row.attention || null,
      coverage_ends_unix: row.coverageEndsUnix || 0,
      coverageEndsString: row.coverageEndsString || "",
    })),
  };
}

function overlayAttention(calendar, byId) {
  if (!calendar || !calendar.rsvns_out || !calendar.id_map || !byId) return calendar;
  const rsvns_out = calendar.rsvns_out.map((item) => {
    if (item.title === "Blocked For Renewal") return item;
    const resId = calendar.id_map.get(String(item.id));
    const attention = byId[resId];
    if (!attention || !attention.shortLabel) return item;
    const style = {...(item.itemProps && item.itemProps.style ? item.itemProps.style : {})};
    let title = item.title || "";
    if (!title.includes(attention.shortLabel)) {
      title = title + " | " + attention.shortLabel;
    }
    if (attention.blocksActivation && attention.beforeStart) {
      style.background = "OrangeRed";
      style.border = "2px solid #7F1D1D";
    }
    return {...item, title, itemProps: {style}};
  });
  return {...calendar, rsvns_out};
}

export default function Reservations() {
  let params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [selected_fleet, updateSelectedFleet] = React.useState([]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fleetsParam = params.get("fleets");
    if (fleetsParam) {
        updateSelectedFleet(fleetsParam.split(",").filter(Boolean));
    } else {
        updateSelectedFleet([]);
    }
  }, [location.search]);


  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const dateString = (d) => {
      var s = d.getFullYear() + "-" +
      ("0" + (d.getMonth()+1)).slice(-2) + "-" +
      ("0" + d.getDate()).slice(-2) + " " +
      ("0" + d.getHours()).slice(-2) + ":" +
      ("0" + d.getMinutes()).slice(-2)
      return s;
  }
  const keys = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start_time",
    itemTimeEndKey: "end_time",
    groupLabelKey: "title"
  };
  const [attentionNote, setAttentionNote] = useState("");
  const [count, setCount] = useState(0);
  const [res_id,setRes_id] = useState("")
  const [reservations, updateReservations] = useState({
    status:"If this message stays - email us at info@joinago.com",
    tz_choices:["ET"],
    drivers:["0:Not A Scheduled Driver"],
    state_count:-1,
    html:"",
    options:"",
    cars: [],
    rsvns: [],
    cars_out: [{ id: 1, title: 'vehicle...' }],
    rsvns_out: [],
    display_start: Date.now()-168*3600000,
    display_end: Date.now()+3*168*3600000,
    id_map: new Map()
  })
  const [sidebarWidth, updateSidebarwidth] = useState(225)
  const [homeTz,setHomeTz] = useState("ET")
  const [searchType,setSearchType] = useState("existing")
  const [driver,setDriver] = useState("0:Not A Scheduled Driver")
  const [windowStartDate, setWindowStartDate] = useState(roundBack(new Date(),12));
  const [resStartDate, setResStartDate] = useState(roundBack(new Date(),-1));
  const [resEndDate, setResEndDate] = useState(roundBack(new Date(),-25));
  const [is_loading, updateIsLoading] = React.useState(false);
  const [windowDays,setWindowDays] = useState(15);
  const [showReservationPage, updateShowReservationPage] = React.useState(false);
  const [showAdvancedSearch, updateShowAdvancedSearch] = React.useState(false);
  const [showAdvancedSearchButton, updateShowAdvancedSearchButton] = React.useState(false);
  const [displaySideDock, updateDisplaySideDock] = React.useState(false);
  const [blankRaLoading, updateBlankRaLoading] = React.useState(false);
  const [blankRaError, updateBlankRaError] = React.useState("");
  const [blankRaUrl, updateBlankRaUrl] = React.useState("");
  
  
  async function downloadBlankRentalAgreement() {
    const fleetCode = selected_fleet[0];
    if (!fleetCode) {
      updateBlankRaError("Select a fleet in the sidebar first.");
      return;
    }
    updateBlankRaLoading(true);
    updateBlankRaError("");
    updateBlankRaUrl("");
    try {
      let session = await Auth.currentSession();
      let jwt = session.getAccessToken().getJwtToken();
      const res = await API.get("adminWebTools", "/ago", {
        queryStringParameters: {
          back_end: process.env.REACT_APP_BACKEND,
          jwt: jwt,
          api_endpoint: "api3:staff:rental_agreement",
          request_type: "GET",
          template: true,
          fleet_code: fleetCode,
        },
      });
      if (res && res.detail) {
        updateBlankRaError(
          "Could not generate the blank rental agreement. " +
            (typeof res.detail === "string" ? res.detail : JSON.stringify(res.detail))
        );
      } else if (res && res.rental_agreement_docx_url) {
        updateBlankRaUrl(res.rental_agreement_docx_url);
      } else {
        updateBlankRaError("Could not generate the blank rental agreement.");
      }
    } catch (e) {
      const detail = e?.response?.data?.detail || e?.message || String(e);
      updateBlankRaError("Could not generate the blank rental agreement. " + detail);
    }
    updateBlankRaLoading(false);
  }

  useEffect(() => {
    const fetchUser = async () => {
      let session = await Auth.currentSession()      
      let user = await Auth.currentAuthenticatedUser(); 
      if(user.signInUserSession.accessToken.payload["cognito:groups"][0] ==='admin')
      {
        updateShowAdvancedSearchButton(true)
      }
    }
    fetchUser();
  }, []);


  const fetchReservationsData = async (tSelectedFleet) => {
    updateIsLoading(true)
    setAttentionNote("")
    var thisFleet = tSelectedFleet ?? selected_fleet[0] ?? "";
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    var jwt = accessToken.getJwtToken()
    let user = await Auth.currentAuthenticatedUser(); 
    const useCalendarApi = searchType === "existing";
    var myInit = {queryStringParameters: useCalendarApi ? {
      back_end: process.env.REACT_APP_BACKEND,
      jwt: jwt,
      api_endpoint: "api3:portal:reservation_calendar",
      request_type: "GET",
      fleet_code: thisFleet,
      driverId: String(parseInt(driver, 10) || 0),
    } : { 
      back_end: process.env.REACT_APP_BACKEND,
      jwt: jwt,
      api_endpoint: "api3:staff:reservations",
      request_type: "POST",
      user_pool_id: user.pool.userPoolId,
      search_type: searchType,
      tz: homeTz,
      window_startS: dateString(windowStartDate),
      window_days: windowDays.toString(),
      driver:parseInt(driver),
      res_startS: dateString(resStartDate),
      res_endS: dateString(resEndDate)
    }};
    if(thisFleet)
    {
      myInit.queryStringParameters.fleet = thisFleet;
    }
    //console.log('getReservations init: '+JSON.stringify(myInit));
    try {
      const payload = await API.get('adminWebTools','/ago',myInit)
      const res = useCalendarApi ? calendarFromApi3(payload) : payload;
      if (res.detail) {
        throw new Error(res.detail);
      }
      if (res.status && res.status !== "success") {
        throw new Error(res.status);
      }
      if (useCalendarApi && res.attentionReady === false) {
        setAttentionNote("Next step did not load. The bars are the open reservations.");
      }
      const cars = Array.isArray(res.cars) ? res.cars : [];
      const rsvns = Array.isArray(res.rsvns) ? res.rsvns : [];
      res.cars = cars;
      res.rsvns = rsvns;
      //console.log(JSON.stringify(res))
      res.state_count = count
    
      const cars_out = [];
      for (let i = 0; i < cars.length; i++) {
        cars_out.push({
          id: cars[cars.length-1-i].id,
          title: cars[cars.length-1-i].name,
        });
      };
      const rsvns_out = []
      const openColorByCar = new Map()
      res.display_start = Date.now()-24*3600000;
      res.display_end =  Date.now()+24*3600000;
      res.id_map = new Map()
      let item_id = 1
      for (let i = 0; i < rsvns.length; i++) {
        res.display_start = Math.min(res.display_start,rsvns[i].start_unix*1000)
        res.display_end = Math.max(res.display_end,rsvns[i].end_unix*1000)
        let l_title = "X-" + rsvns[i].status + "-X"
        let bgc = 'Red'
        if (rsvns[i].status === 'pre') 
        {
          bgc = 'Plum'
          l_title = "Temp Blocked"
        } 
        else if (rsvns[i].status === 'deposit') 
        {
          bgc = 'LightSalmon'
          l_title = rsvns[i].driverName  + ",S:" + rsvns[i].startString + ",E:" + rsvns[i].endString + ",#:" + rsvns[i].res_id + "," + rsvns[i].status
        } 
        else if (rsvns[i].status === 'price') 
        {
          bgc = 'MediumAquaMarine'
          l_title = rsvns[i].driverName  + ",S:" + rsvns[i].startString + ",E:" + rsvns[i].endString + ",#:" + rsvns[i].res_id + "," + rsvns[i].status
        } 
        else if (rsvns[i].status === 'remaining')
        {
          bgc = 'MediumAquaMarine'
          l_title = rsvns[i].driverName  + ",S:" + rsvns[i].startString + ",E:" + rsvns[i].endString + ",#:" + rsvns[i].res_id + "," + rsvns[i].status
        }
        else if (rsvns[i].status === 'extension')
        {
          bgc =  'AquaMarine' 
          l_title = rsvns[i].driverName  + ",S:" + rsvns[i].startString + ",E:" + rsvns[i].endString + ",#:" + rsvns[i].res_id + "," + rsvns[i].status
        }
        else if (rsvns[i].status === 'available')
        {
          bgc =  'DarkGrey' 
          l_title = 'available'
        }
        else if (rsvns[i].status === 'returned')
        {
          bgc =  'DarkGreen'
          l_title = 'returned'
        }
        else if (rsvns[i].status === 'buffer')
        {
          bgc =  'DarkOliveGreen' 
          l_title = ''
        };
        const queueStyle = queueTimelineStyle(rsvns[i], bgc);
        l_title = queueTimelineTitle(rsvns[i], l_title);
        const bufferStripe = insuranceBufferStripe(
          rsvns[i].start_unix,
          rsvns[i].end_unix,
          rsvns[i].coverage_ends_unix,
        );
        const barStyle = bufferStripe ? hatchedBarStyle(queueStyle, bufferStripe.fraction) : queueStyle;
        if (bufferStripe) {
          l_title += " | Insurance buffer under 1 day";
          if (rsvns[i].coverageEndsString) {
            l_title += ", coverage through " + rsvns[i].coverageEndsString;
          }
        }
        if (OPEN_RESERVATION_STATUSES.has(rsvns[i].status)) {
          const carKey = String(rsvns[i].carId);
          const start = rsvns[i].start_unix;
          const prev = openColorByCar.get(carKey);
          if (!prev || start < prev.start) {
            openColorByCar.set(carKey, {
              start,
              background: queueStyle.background,
            });
          }
        }
        rsvns_out.push({
          id: item_id,
          group: rsvns[i].carId,
          start_time: rsvns[i].start_unix*1000,
          end_time: rsvns[i].end_unix*1000,
          title: l_title ,
          canMove: false,
          canResize: false,
          canChangeGroup: false,
          itemProps: {
            style: barStyle
          }
        });
        res.id_map.set(item_id.toString(),rsvns[i].res_id)
        item_id = item_id + 1
        if (rsvns[i].end_unix !== rsvns[i].block_end_unix) {
          rsvns_out.push({
            id: item_id,
            group: rsvns[i].carId,
            start_time: rsvns[i].end_unix*1000,
            end_time: rsvns[i].block_end_unix*1000,
            title: "Blocked For Renewal",
            canMove: false,
            canResize: false,
            canChangeGroup: false,
            itemProps: {
              style: {
                background: 'LightBlue',
                padding:'0px'
              }
            }
          });
          res.id_map.set(item_id.toString(),rsvns[i].res_id)
          item_id = item_id + 1
        };
      };
      const attentionByCar = new Map();
      rsvns.forEach((row) => {
        const attention = row && row.operatorAttention;
        if (!attention || !attention.blocksActivation || !attention.beforeStart) return;
        const line = attention.sentence || attention.shortLabel;
        if (!line) return;
        const carKey = String(row.carId);
        const existing = attentionByCar.get(carKey) || [];
        if (!existing.includes(line)) existing.push(line);
        attentionByCar.set(carKey, existing);
      });
      for (let i = 0; i < cars_out.length; i++) {
        const open = openColorByCar.get(String(cars_out[i].id));
        if (open) {
          cars_out[i].openBackground = open.background;
        }
        const lines = attentionByCar.get(String(cars_out[i].id));
        if (lines && lines.length) {
          cars_out[i].attentionNote = lines.join("\n");
        }
      }
      res.cars_out = [].concat(cars_out)
      res.rsvns_out = [].concat(rsvns_out)
      const byId = {};
      rsvns.forEach((row) => {
        if (row && row.operatorAttention && row.res_id) byId[row.res_id] = row.operatorAttention;
      });
      const painted = overlayAttention(res, byId);
      res.rsvns_out = painted.rsvns_out;
      const titlesByCar = new Map();
      painted.rsvns_out.forEach((item) => {
        if (!item || !item.title || item.title === "Blocked For Renewal") return;
        const carKey = String(item.group);
        const existing = titlesByCar.get(carKey) || [];
        if (!existing.includes(item.title)) existing.push(item.title);
        titlesByCar.set(carKey, existing);
      });
      res.cars_out.forEach((car) => {
        const titles = titlesByCar.get(String(car.id));
        if (titles && titles.length) car.reservationTitle = titles.join("\n");
      });
      
      res.display_start = Date.now()-168*3600000
      res.display_end = Date.now()+3*168*3600000

      updateReservations(res);

      /* crazily this switch of res_id enforces flushing and updating of timeline data - so dont alter */
      /* also dont modify the showing of the res_id in html where it is */
      /* clearly need to figure this out or switch from using calendar-timeline at some point */

      if (res_id === 'x') {
        setRes_id("-")
      }
      else
      {
        setRes_id("x")
      }

      if ('max_name_width' in res)
      {
        var maxLabelStrLength = res.max_name_width;
        
        var maxWidth = 400;
        var minWidth = 225;
        var padding = 2;
        var widthPerChar = 9; // pixels per character (adjust as needed)
        var thissidebarwidth = maxLabelStrLength * widthPerChar + padding; // add some padding
        if(thissidebarwidth < minWidth)
        {
          thissidebarwidth = minWidth
        }
        if(thissidebarwidth > maxWidth)
        {
          thissidebarwidth = maxWidth
        }
        updateSidebarwidth(thissidebarwidth)
      }

      updateIsLoading(false)
    }
    catch (e) {
        const res = {status:"Error retrieving Reservations or User not permissioned - email us at info@joinago.com: " + e.toString()};
        res.state_count = count
        updateReservations(res);
        if (res_id === 'X') {
          setRes_id("-")
        }
        else
        {
          setRes_id("X")
        }
        updateIsLoading(false)
    }
  }


  useEffect(() => {
    if (selected_fleet.length > 0) {
      fetchReservationsData(selected_fleet[0]);
    }
  }, [
    count,
    homeTz,
    searchType,
    windowStartDate,
    windowDays,
    driver,
    resStartDate,
    resEndDate,
    selected_fleet
  ]);



  const ReRoute = (resId) => {
    let urlTo = '../reservation/' + resId + '?fleets=' + selected_fleet;
    navigate(urlTo);
  }


  const SelectReservation = async (resId) => {
    await setRes_id(resId);
    if(displaySideDock===false)
    {
      ReRoute(resId);
      //return <Navigate to={urlTo} />
      //updateShowReservationPage(true);
    } else {
      await updateDisplaySideDock(false);
      updateDisplaySideDock(true);
    }
  }

  return (  
      <Flex direction="column">
        {
        showReservationPage ? <ReservationNew resId={res_id} /> :
        <View style={{padding:"1rem"}}>
          <Heading level={1}>Reservations</Heading>
          <Text>These are the recent, current, and upcoming reservations booked on your vehicles through the mobile app</Text>
          <br/>
            {showAdvancedSearch ?
                <View>
                    <Flex direction="row" alignItems="flex-start">
                      <SelectField
                        label="Home Timezone"
                        descriptiveText="Select your home timezone..."
                        size="small"
                        options={reservations.tz_choices}
                        value={homeTz}
                        onChange={(e) => setHomeTz(e.target.value)}
                      ></SelectField>
                      <SelectField
                        label="Search Type"
                        descriptiveText="Select search type..."
                        size="small"
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                      >
                        <option value="existing" label="Existing Rsvns"></option>
                        <option value="availability" label="Test Availability"></option>
                        <option value="reservations" label="Request Rsvns"></option>  
                      </SelectField>
                      <SelectField
                        label="Driver"
                        descriptiveText="Select Driver here only for testing scheduling..."
                        size="small"
                        options={reservations.drivers}
                        value={driver}
                        onChange={(e) => setDriver(e.target.value)}
                      ></SelectField>
                    </Flex>
                    <Flex direction="row" alignItems="flex-start">
                      <Flex direction="column" alignItems="flex-start">
                        <Text>Window Start</Text>
                        <DatePicker
                              name="Window Start"
                              selected={windowStartDate}
                              onChange={(date) => setWindowStartDate(date)}
                              showTimeSelect
                              dateFormat="MMMM d, yyyy h:mm aa"
                              timeIntervals={60}
                            />
                        <SliderField label="Days in Window" value={windowDays} onChange={setWindowDays} min={7} max={90} step={1}/>
                      </Flex> 
                      <Flex direction="column" alignItems="flex-start">
                        <Text>Shift Request Start</Text>
                        <DatePicker
                              selected={resStartDate}
                              onChange={(date) => setResStartDate(date)}
                              showTimeSelect
                              dateFormat="MMMM d, yyyy h:mm aa"
                              timeIntervals={60}
                            />
                      </Flex>
                      <Flex direction="column" alignItems="flex-start">
                        <Text>Shift Request End</Text>
                        <DatePicker
                              selected={resEndDate}
                              onChange={(date) => setResEndDate(date)}
                              showTimeSelect
                              dateFormat="MMMM d, yyyy h:mm aa"
                              timeIntervals={60}
                            />
                      </Flex> 
                    </Flex>

                    <Button onClick={() => setCount(count + 1)}>
                                Submit
                    </Button>
                    <br /><br />
                    <Button onClick={() => updateShowAdvancedSearch(false)}>
                      Hide Advanced Search
                    </Button>
                    <br />
                  </View>
              :
                showAdvancedSearchButton ?
                <View>
                  <Button onClick={() => updateShowAdvancedSearch(true)}>
                    REVEAL ADVANCED SEARCH
                  </Button>
                  <br />
                  <br />
                </View>
                :
                  undefined
            }
            <View>
              <Button onClick={() => setCount(count + 1)}>
                  PRESS TO GET LATEST UPDATES
              </Button>
            </View>
            <Divider />
            {attentionNote ? <Text>{attentionNote}</Text> : undefined}
            <Text>
              <span style={{display:'block', fontWeight:700, fontSize:'1.1rem', color:'#fff', background:'#7F1D1D', padding:'6px 10px', marginBottom:'8px'}}>
                Hover over resvn or vehicle to get next action.
              </span>
              <i>Hint: <span style={{background:'DarkOrange', padding:'0 4px'}}>Dark orange</span> = cancel/close pending approval (see Cancel/Close Review). <span style={{background:'Gold', padding:'0 4px'}}>Gold</span> = handoff warning only (not actionable). <span style={{background:'OrangeRed', color:'#fff', padding:'0 4px'}}>Orange red</span> = blocked before the start. <span style={{background:'repeating-linear-gradient(-45deg, #6d28d9 0 4px, #ddd6fe 4px 8px)', padding:'0 4px'}}>Purple hatch</span> = purchased insurance has less than one day of buffer left, drawn from one day before coverage ends through the return. A * on the right of the vehicle name is that same block. Red = other status needs attention. A vehicle name uses the same color as its oldest open reservation (deposit, price, remaining, or extension).</i>
            </Text>
            <br/>
            {is_loading ? <Loadingmini /> :
              selected_fleet.length < 1 ? <Text><i>Select a fleet using the sidebar fleet selector, then open Reservations again.</i></Text> :
              reservations.status !== "success" ? <View><Text>{reservations.status}</Text></View> :
                <Flex gap="2rem" wrap="wrap">
                  <Flex direction="column">
                    <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem" alignItems="center" style={displaySideDock ? {width:"25vw"} : {width:"80vw"}}>
                      <Reservationcreate fleetCode={selected_fleet[0]} refreshParent={fetchReservationsData}/>
                      <Button
                        onClick={() => downloadBlankRentalAgreement()}
                        isDisabled={blankRaLoading || !selected_fleet[0]}
                      >
                        {blankRaLoading ? "GENERATING BLANK…" : "DOWNLOAD BLANK RENTAL AGREEMENT"}
                      </Button>
                    </Flex>
                    {blankRaError ? <Text>{blankRaError}</Text> : undefined}
                    {blankRaUrl ? (
                      <Text>
                        <a href={blankRaUrl} rel="noreferrer" target="_blank">
                          Download blank rental agreement
                        </a>
                        {" "}(link expires in 15 minutes)
                      </Text>
                    ) : undefined}
                    {
                    /*
                    <h5> Selected Res Id: {res_id} </h5>
                    res_id!=='x' && res_id!=='' ? 
                      <span><Button onClick={() => updateShowConfirmCloseReservation(true)}>
                                  Close Reservation
                      </Button><br/><p>{JSON.stringify(closeReservationResults)!=='{}' ? JSON.stringify(closeReservationResults) : undefined}</p><br/></span> : undefined
                    */}
                    <Flex direction="column" style={displaySideDock ? {width:"25vw"} : {width:"80vw"}}>
                      <Timeline 
                        groups={reservations.cars_out}
                        items={reservations.rsvns_out}
                        groupRenderer={vehicleGroupRenderer}
                        keys={keys}
                        defaultTimeStart={new Date(reservations.display_start)}
                        defaultTimeEnd={new Date( reservations.display_end)}
                        sidebarWidth={sidebarWidth}
                        canMove={true}
                        canChangeGrop={false}
                        canResize={true}
                        showCursorLine
                        onItemSelect={(itemId, e, time) => {
                          SelectReservation(reservations.id_map.get(itemId.toString()))
                        }}   
                      >
                        <TimelineMarkers>
                          <TodayMarker interval={2000} />
                        </TimelineMarkers>
                        <TimelineHeaders style={{background: '#092F50', color:'#FFF', padding:'25px'}}>
                          <SidebarHeader>
                            {({ getRootProps }) => {
                              return <View {...getRootProps()}><Heading level={4} style={{color:'#FFF', paddingRight:'25px'}}>Vehicles</Heading></View>
                            }}
                          </SidebarHeader>
                        </TimelineHeaders>
                      </Timeline>           
                      <iframe id="reservations"   
                              title="Reservations"
                              width="80vw"
                              height="500"
                              srcdoc = {reservations.options} 
                      > 
                      </iframe>
                    </Flex>
                    {
                      /*<p> Updated on this use: {count} </p>*/
                    }
                  </Flex>
                  {
                    displaySideDock === false ? 
                      <Flex direction="column">
                        <Divider />
                          <Button onClick={() => updateDisplaySideDock(true)}>
                              ACTIVATE SIDE DOCK
                          </Button>
                        <Divider />
                      </Flex> 
                    :
                      res_id==="x" || res_id==="-"? <Text><i>Please select a reservation by clicking it...</i></Text> :
                      <Flex direction="column" style={{width:"30vw"}}>
                        <Divider />
                        <Heading level={2}>Reservation Details</Heading>
                        <Text><Button style={{border:'none', fontStyle: 'italic', marginLeft:'-15px'}} onClick={() => updateDisplaySideDock(false)}>To open reservations in full-screen mode, click here to hide the side dock.</Button></Text>
                        <ReservationNew resId={res_id} />
                        <Divider />
                      </Flex>
                  }
                </Flex>
            }
        </View>}
      </Flex>

  );
}